<claas-horizontal-scroll-helper
  [scrollTarget]="scrollContainer"
></claas-horizontal-scroll-helper>
<div #scrollContainer class="products-compare-tech-data">
  <div class="controls">
    <div class="select-wrap">
      <claas-products-comparisons-selects
        class="selects"
      ></claas-products-comparisons-selects>

      <div class="data-container">
        @for (spec of techData(); track $index) {
          <div class="data-row">
            <p class="spec-name">
              <span class="spec-text">{{ spec.Category.Category }}</span>
            </p>

            <span class="claas-spec-value">{{ spec.Value }}</span>
            <span class="competitor-spec-value">{{
              spec.competitorSpecValue ?? "-"
            }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
